import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';
import { media } from '../utils/styles/media.js';

const StyledDiv = styled.div.withConfig({
  componentId: "sg1510__sc-1dqkcle-0"
})(["flex:1 1 auto;padding:", ";position:relative;", "{padding:", ";}"], tokens.space.md, media.md, tokens.space.xl);
const ModalBody = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledDiv, null, children);
};
ModalBody.displayName = 'ModalBody';
ModalBody.propTypes = {
  /**
   * Modal main content.
   */
  children: PropTypes.node
};

export { ModalBody };
